class IspLoginJobModel {
	private jobHash: string;
	private maxRetries: number;
	private retryDelay: number;

    constructor(data: any) {
        Object.assign(this, data);
    }
}

export default IspLoginJobModel;